/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_QueueInputs */



/**
* | output |
* | --- |
* | "Job Queue" |
*
* @param {Job_QueueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_queue = /** @type {((inputs?: Job_QueueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_QueueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("File d’attente")
	if (locale === "de") return /** @type {LocalizedString} */ ("Jobwarteschlange")
	if (locale === "it") return /** @type {LocalizedString} */ ("Coda di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очередь заданий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cola de trabajos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("作业队列")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ジョブキュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी कतार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fila de tarefas")
	return /** @type {LocalizedString} */ ("Job Queue")
});